export default class SyndisData {
  constructor(
    emailList = [''],
    phoneList = [''],
    ssnList = [''],
    description = ''
  ) {
    this._emailList = emailList.length === 0 ? [''] : emailList;
    this._phoneList = phoneList.length === 0 ? [''] : phoneList;
    this._ssnList = ssnList.length === 0 ? [''] : ssnList;
    this._description = description.length === 0 ? '' : description;
  }

  set emailList(emailList) {
    this._emailList = emailList;
  }

  get emailList() {
    return this._emailList;
  }

  set phoneList(phoneList) {
    this._phoneList = phoneList;
  }

  get phoneList() {
    return this._phoneList;
  }

  set ssnList(ssnList) {
    this._ssnList = ssnList;
  }

  get ssnList() {
    return this._ssnList;
  }

  set description(description) {
    this._description = description;
  }

  get description() {
    return this._description;
  }

  clear() {
    this._emailList = [''];
    this._phoneList = [''];
    this._ssnList = [''];
    this._description = '';
  }
}
